"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var pathUtil = require("@antv/path-util");
var category_1 = require("@antv/scale/lib/category");
var linear_1 = require("@antv/scale/lib/linear");
var _ = require("@antv/util");
/**
 * 点数组转 path
 * @param points
 */
function pointsToPath(points) {
    return _.map(points, function (p, idx) {
        var command = idx === 0 ? 'M' : 'L';
        var x = p[0], y = p[1];
        return [command, x, y];
    });
}
/**
 * 将点连接成路径 path
 * @param points
 */
function getLinePath(points) {
    return pointsToPath(points);
}
exports.getLinePath = getLinePath;
/**
 * 将点连成平滑的曲线
 * @param points
 */
function getSmoothLinePath(points) {
    if (points.length <= 2) {
        // 两点以内直接绘制成路径
        return getLinePath(points);
    }
    var data = [];
    _.each(points, function (p) {
        // 当前点和上一个点一样的时候，忽略掉
        if (!_.isEqual(p, data.slice(data.length - 2))) {
            data.push(p[0], p[1]);
        }
    });
    // const constraint = [ // 范围
    //   [ 0, 0 ],
    //   [ 1, 1 ],
    // ];
    var path = pathUtil.catmullRom2Bezier(data, false);
    var _a = _.head(points), x = _a[0], y = _a[1];
    path.unshift(['M', x, y]);
    return path;
}
exports.getSmoothLinePath = getSmoothLinePath;
/**
 * 将数据转成 path，利用 scale 的归一化能力
 * @param data
 * @param width
 * @param height
 * @param smooth
 */
function dataToPath(data, width, height, smooth) {
    if (smooth === void 0) { smooth = true; }
    // 利用 scale 来获取 y 上的映射
    var y = new linear_1.default({
        values: data,
    });
    var x = new category_1.default({
        values: _.map(data, function (v, idx) { return idx; }),
    });
    var points = _.map(data, function (v, idx) {
        return [x.scale(idx) * width, height - y.scale(v) * height];
    });
    return smooth ? getSmoothLinePath(points) : getLinePath(points);
}
exports.dataToPath = dataToPath;
/**
 * 线 path 转 area path
 * @param path
 * @param width
 * @param height
 */
function linePathToAreaPath(path, width, height) {
    var areaPath = tslib_1.__spreadArrays(path);
    areaPath.push(['L', width, 0]);
    areaPath.push(['L', 0, height]);
    areaPath.push(['Z']);
    return areaPath;
}
exports.linePathToAreaPath = linePathToAreaPath;
//# sourceMappingURL=path.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/gui/lib/trend/path.js
// module id = 1054
// module chunks = 37